<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
        <i class="fa fa-user-circle fa-2x"/>
    </template>\
    <template slot="dropdown">
      <b-dropdown-header
        tag="div"
        class="text-center">
        <strong>Settings</strong>
      </b-dropdown-header>
      <b-dropdown-item @click="UserProfilePage"><i class="fa fa-user" /> Profile</b-dropdown-item>
      <!-- <b-dropdown-divider /> -->
      <!-- <b-dropdown-item><i class="fa fa-shield" /> Lock Account</b-dropdown-item> -->
      <b-dropdown-item @click="LogoutPage"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import * as types from '@/store/types'
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'

export default {
  name: 'HeaderDropdown',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  methods: {
    LogoutPage () {
      // clear local storage
      window.localStorage.clear()
      
      // clear state
      this.$store.commit(types.MUTATE_RESET_STATE)
      this.$store.commit(types.MUTATE_RESET_TOKEN)

      // redirect to login
      this.$router.push('/login') 
    },

    UserProfilePage() {

      this.$store.dispatch(types.ACTION_FIND_USER_BY_ID, this.$store.state.userId)
        // redirect to login
      this.$router.push('/user-profile')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/HeaderDropdown.vue